"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var snarkdown_1 = require("snarkdown");
var markdownTextStyles_1 = require("./markdownTextStyles");
var core_1 = require("@material-ui/core");
var MarkdownText = function (_a) {
    var label = _a.formData.label;
    var styles = markdownTextStyles_1.default();
    return (<core_1.Typography className={styles.text} dangerouslySetInnerHTML={{ __html: snarkdown_1.default(label) }} data-test="text:enquiryForm:markdownText"/>);
};
exports.default = MarkdownText;
